import { z } from 'zod';
// import { parsePhoneNumberFromString } from "libphonenumber-js";

interface GeoLocation {
  latitude: number;
  longitude: number;
}

export interface UserInterface {
  first_name: string;
  last_name: string;
  username: string;
  email: string;
  business_name: string;
  is_verified: boolean;
  nationality_country_id: number;
  residency_country_id: number;
  residency_city: string;
  residency_postal_code: string;
  phone_number: string | null;
  whatsapp_number: string | null;
  telegram_number: string | null;
  wechat_number: string | null;
  marital_status: string | null;
  gender: string | null;
  bio: string | null;
  geo_location: GeoLocation;
  is_onboarded: boolean;
  profile_picture_url:string;
  latitude?: number;
  longitude?: number;
}

// -- profile setup
export type OnboardingType = {
  username: string;
  nationality: number;
  longitude: number;
  latitude: number;
};
export type UserOnboardingType = {
  username: string;
  nationality: number;
  longitude: number;
  latitude: number;
  first_name: string;
  last_name: string;
  email: string;
  whatsapp_number: string | number;
  marital_status: string;
  gender: string;
  bio: string;
  profile_picture: File | null;
};

export type ProfileSetupType = {
  username: string;
  nationalityId: number;
  cityId: number;
};

export const ProfileSetupDefault: ProfileSetupType = {
  username: '',
  nationalityId: -1,
  cityId: -1,
};

export const ProfileSetupSchema = z.object({
  username: z.string().min(3, 'Enter a nickname'),
  nationalityId: z.number().min(1, 'Select your Nationality'),
  cityId: z.number().min(1, 'Select your City'),
});

// Account setup
export type AccountSetupType = {
  first_name: string;
  last_name: string;
  username?: string; // Changed from required to optional to match schema
  business_name?: string;
  business_description?: string;
  profession?: string;
  hobby?: string;
  email: string;
  nationality_country_id: number;
  telegram_number?: string;
  wechat_number?: string;
  whatsapp_number?: string;
  marital_status?: string;
  religion?: string;
  gender?: string;
  bio?: string;
  business_open?: string;
  business_close?: string;
};

export const AccountSetupSchema = z.object({
  first_name: z.string().min(1, 'Enter a first name'),
  last_name: z.string().min(1, 'Enter a last name'),
  username: z.string().optional(),
  business_name: z.string().optional(),
  business_description: z.string().optional(),
  profession: z.string().optional(),
  hobby: z.string().optional(),
  email: z.string().email('Enter a valid email'),
  nationality_country_id: z.number().min(1, 'Select your Nationality'),
  whatsapp_number: z.string().optional(),
  telegram_number: z.string().optional(),
  wechat_number: z.string().optional(),
  marital_status: z.string().optional(),
  religion: z.string().optional(),
  gender: z.string().min(1, 'Please select a gender'),
  bio: z.string().optional(),
  business_open: z.string().optional(),
  business_close: z.string().optional(),
});